import { render, staticRenderFns } from "./UnifiedSearchLocalSearchBar.vue?vue&type=template&id=0733c47e&scoped=true"
import script from "./UnifiedSearchLocalSearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnifiedSearchLocalSearchBar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UnifiedSearchLocalSearchBar.vue?vue&type=style&index=0&id=0733c47e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733c47e",
  null
  
)

export default component.exports